import { render, staticRenderFns } from "./CenterFrame.vue?vue&type=template&id=b38945f8"
import script from "./CenterFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./CenterFrame.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports